module.exports = __webpack_public_path__ + "static/img/wine.c7116238.jpg";